module.exports = __webpack_public_path__ + "static/header-image-congress-28ba5681e6c2f8d47a387a1b05858e72.png";